import React from 'react';
import { formatAddress } from '../utils/web3';

function WalletConnect({ account, onConnect, loading }) {
  if (account) {
    return (
      <div className="wallet-info">
        <span className="wallet-address" style={{ 
          fontFamily: 'monospace',
          color: 'var(--text-gold)',
          fontWeight: 'bold'
        }}>
          💛 {formatAddress(account)}
        </span>
        <span style={{ 
          color: 'var(--emerald)',
          fontSize: '12px',
          animation: 'pulse 2s ease-in-out infinite'
        }}>
          ●
        </span>
      </div>
    );
  }

  return (
    <button 
      className="btn btn-primary" 
      onClick={onConnect}
      disabled={loading}
      style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
    >
      {loading ? (
        <>
          <div className="loading"></div>
          <span>Connecting...</span>
        </>
      ) : (
        <>
          <span>💛</span>
          <span>Connect Wallet</span>
        </>
      )}
    </button>
  );
}

export default WalletConnect;